import { dot } from "./vec3";

export const projectScenePoint = (view, p) => ({
  x: view.originX + dot(p, view.right) * view.scale,
  y: view.originY - dot(p, view.up) * view.scale,
});

/** Translate on the support plane, including its rise/fall on a pitched roof. */
export function sceneDragDelta(view, dx, dy, gradient = { x: 0, y: 0 }) {
  const a = view.right.x + view.right.z * gradient.x;
  const b = view.right.y + view.right.z * gradient.y;
  const c = view.up.x + view.up.z * gradient.x;
  const d = view.up.y + view.up.z * gradient.y;
  const det = a * d - b * c;
  if (Math.abs(det) < 0.05 || !(view.scale > 0)) return null;
  const x = dx / view.scale, y = -dy / view.scale;
  return { x: (x * d - b * y) / det, y: (a * y - x * c) / det };
}

/** Pick the nearest visible triangle, so objects behind a roof cannot be grabbed. */
export function pickSceneObject(view, point, targets) {
  let picked = null, nearest = -Infinity;
  for (const target of targets) {
    const mesh = target.mesh;
    for (let i = 0; i < (mesh?.length || 0); i += 9) {
      const world = [0, 3, 6].map((j) => ({ x: mesh[i + j], y: mesh[i + j + 1], z: mesh[i + j + 2] }));
      const [a, b, c] = world.map((p) => projectScenePoint(view, p));
      const den = (b.y - c.y) * (a.x - c.x) + (c.x - b.x) * (a.y - c.y);
      if (Math.abs(den) < 1e-8) continue;
      const u = ((b.y - c.y) * (point.x - c.x) + (c.x - b.x) * (point.y - c.y)) / den;
      const v = ((c.y - a.y) * (point.x - c.x) + (a.x - c.x) * (point.y - c.y)) / den;
      if (u < -1e-6 || v < -1e-6 || u + v > 1 + 1e-6) continue;
      const depth = u * dot(world[0], view.direction) + v * dot(world[1], view.direction) + (1 - u - v) * dot(world[2], view.direction);
      if (depth > nearest) { nearest = depth; picked = target; }
    }
  }
  return picked?.editable === false ? null : picked;
}
